import React from "react";
import "./news";
import { Link } from "react-router-dom";


const DesktopNewsElement = ({ key, id, title, imageUrl, firstParagraph, relaseDate }) => {
    if (id % 2 == 0)
        return (
            <React.Fragment key={key}>
                <Link to={`/newsDetail/${id}`} >
                    <div className="row align-items-center redback">
                        <col className="col-1"></col>
                        <div className="col-4 figure-title" >
                            <h4>
                                {title}
                            </h4>
                            <br />
                            {firstParagraph}
                        </div>
                        <div className="col-1 figure-caption">
                            <div className="redDesktopTime">{relaseDate}</div>
                        </div>
                        <col className="col-1"></col>
                       <div className="col-5">
                            <img src={`${imageUrl}`} className="desktopRigth-figure-img img-fluid " alt="..." />
                        </div>
                    </div>
                </Link>
            </React.Fragment >
        );
    else
        return (
            <React.Fragment key={key}>
                <Link to={`/newsDetail/${id}`} >
                    <div className="row align-items-center ">
                        <div className="col-5">
                            <img src={`${imageUrl}`} className="desktopLeft-figure-img img-fluid " alt="..." />
                        </div>
                        <col className="col-1"></col>
                        <div className="col-4 figure-title" >
                            <h4>
                                {title}
                            </h4>
                            <br />
                            {firstParagraph}
                        </div>
                        <div className="col-1 figure-caption">
                            <div className="desktopTime">{relaseDate}</div>
                        </div>
                    </div>
                </Link>
            </React.Fragment >
        );
};

export default DesktopNewsElement;
